"use strict";
/*jshint esversion: 11 */

import PivotalSearchApi from "../../../../js/csf/pivotal/PivotalSearchApi";
import PivotalFormApi from "../../../../js/csf/pivotal/PivotalFormApi";
import PivotalApiEnvironments
  from "../../../../js/csf/pivotal/PivotalApiEnvironments";

class CsfMembreConsentModalDataLayer {

  constructor(apiUrl, apiEnv, accessToken, fnApiCallbackError) {
    this.accessToken = accessToken;
    this.apiUrl = apiUrl;
    this.apiEnv = apiEnv;
    this.isInit = true;
    this.apiErrorCallback = fnApiCallbackError;
  }


  fetchConsentsInfo (setConsents) {
    const requestData = {
      search: 'EM_Consent_Current_User',
      searchResultsList: 'CSF_EM_CRC_Consentement_Histo'
    };
    const pivotalSearchApi = new PivotalSearchApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          const consentList = response.payload.data.rows;
          setConsents(consentList);
        } else {
          console.log("Error fetching consents info");
        }
      })
      .catch(error => {
        console.error(error);
        this.apiErrorCallback(error);
      });
  }


  submitConsents(recordId, formData, dismissButton, setIsError) {
    let requestData = {
      form: 'CSF_EM_Consent_Rest',
      recordId: recordId,
      deltaData: formData
    };

    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success) {
          dismissButton.current.click();
          console.log("submitted successfully");
        } else {
          console.log("error in CSF_EM_Consent_Rest");
          setIsError(true);
        }
      })
      .catch(error => {
        console.log("error in CSF_EM_Consent_Rest");
        setIsError(true);
      });
  }

}

export default CsfMembreConsentModalDataLayer;
